const BrandIntro = () => (
  <section
    id="brand-intro"
    data-testid="brand-intro"
    className="py-20 md:py-28 bg-[hsl(var(--background))]"
  >
    <div className="container-tjb grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
      <div className="lg:col-span-5">
        <p className="eyebrow">Made for Bali Days</p>
        <h2 className="h-section mt-4">
          Linen-focused outfits, <br className="hidden md:block" />
          made for tropical days.
        </h2>
      </div>
      <div className="lg:col-span-7 lg:pl-10 space-y-5 text-base md:text-lg text-[hsl(var(--ink))]/80 leading-relaxed">
        <p>
          Triple J Bali offers linen-focused clothing and resort wear for
          tropical days, beach walks, dinner plans, and easy everyday styling
          in Bali. Visit us in Canggu or Ubud and find breathable pieces made
          to feel relaxed, clean, and elegant.
        </p>
        <p className="text-[hsl(var(--muted-foreground))] text-[15px]">
          Most of our collection is original linen, with selected cotton, silk,
          and linen-cotton pieces available depending on the design.
        </p>
        <div className="pt-6 grid grid-cols-3 gap-4 max-w-md">
          <div className="border-t border-[hsl(var(--border))] pt-4">
            <p className="font-display text-3xl">29+</p>
            <p className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))] mt-1">Styles</p>
          </div>
          <div className="border-t border-[hsl(var(--border))] pt-4">
            <p className="font-display text-3xl">2</p>
            <p className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))] mt-1">Stores</p>
          </div>
          <div className="border-t border-[hsl(var(--border))] pt-4">
            <p className="font-display text-3xl">5.0</p>
            <p className="text-xs uppercase tracking-wider text-[hsl(var(--muted-foreground))] mt-1">Google ★</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BrandIntro;
